import React, { useState } from 'react';
import { UserTableMetric } from '../../types/business-metrics';
import { Avatar } from 'primereact/avatar';
import './MetricsUserTable.scss';
import { Card } from 'primereact/card';
import { getUserAvatarProps } from '../../utils/avatarUtils';
import classNames from 'classnames';
import { CardEmptyState } from '../../pages/BusinessAnalytics/components/CardEmptyState';
import { useNavigateScroll } from '../../hooks/useNavigateScroll';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { PrimeIcons } from 'primereact/api';

const MAX_USERS_TO_SHOW = 8;

interface Props {
  data: UserTableMetric[];
  title: string;
  className?: string;
  isEmpty?: boolean;
  emptyStateText: string;
  simpleList?: boolean;
}

export const MetricsUserTable = ({ data, title, className, isEmpty, emptyStateText, simpleList = false }: Props) => {
  const navigate = useNavigateScroll();
  const [showModal, setShowModal] = useState(false);

  const usersToShow = data.slice(0, MAX_USERS_TO_SHOW);
  const showMoreUsers = data.length > MAX_USERS_TO_SHOW;

  const handleUserClick = (id: string) => {
    navigate(`/users/profile/${id}`);
  };

  const renderUserRow = (user: UserTableMetric, index: number) => (
    <div key={user.externalUserId} className='table-row' onClick={() => handleUserClick(user.externalUserId)}>
      <div className='user-info'>
        {!simpleList && <span className='rank'>{index + 1}</span>}
        <Avatar {...getUserAvatarProps(user)} shape='circle' size='normal' />
        <span className='name'>
          {user.name} {user.surnames}
        </span>
      </div>
      {!simpleList && <span className='value'>{user.value}</span>}
    </div>
  );

  const cardTitle = (
    <div className='card-title-with-button'>
      <span>{title}</span>
      {showMoreUsers && (
        <Button
          label='Ver todos'
          icon={PrimeIcons.EXTERNAL_LINK}
          className='p-button-text p-button-sm'
          onClick={() => setShowModal(true)}
        />
      )}
    </div>
  );

  return (
    <>
      <Card title={cardTitle} className={classNames('metrics-user-table', className)}>
        {isEmpty ? (
          <CardEmptyState text={emptyStateText} />
        ) : (
          <div className='table-content'>{usersToShow.map((user, index) => renderUserRow(user, index))}</div>
        )}
      </Card>

      <Dialog
        header={title}
        visible={showModal}
        onHide={() => setShowModal(false)}
        className='metrics-user-table-modal big-modal'
        draggable={false}
        resizable={false}
        dismissableMask
      >
        <div className='table-content'>{data.map((user, index) => renderUserRow(user, index))}</div>
      </Dialog>
    </>
  );
};
